var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstablishmentHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 140 130",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.928 74.8115C129.928 75.0876 130.152 75.3115 130.428 75.3115C130.704 75.3115 130.928 75.0876 130.928 74.8115H129.928ZM129.928 40.4717V74.8115H130.928V40.4717H129.928Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.624 65.213C26.4574 65.1178 26.25 65.2381 26.25 65.4301V99.9996C26.25 99.9996 26.25 130 70 130C113.75 130 113.75 99.9996 113.75 99.9996V65.4301C113.75 65.2381 113.543 65.1178 113.376 65.213L70.4961 89.7159C70.1887 89.8916 69.8113 89.8916 69.5039 89.7159L26.624 65.213Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.763064 39.4242L69.7526 0.140877C69.906 0.0535418 70.094 0.0535432 70.2474 0.140878L139.237 39.4242C139.574 39.616 139.574 40.1015 139.237 40.2932L70.2474 79.5766C70.094 79.6639 69.906 79.6639 69.7526 79.5766L0.763068 40.2932C0.426279 40.1015 0.426275 39.616 0.763064 39.4242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishmentHover);
export default __webpack_public_path__ + "static/media/establishmentHover.b500bd9a6129590a634a4fcbff7d09b7.svg";
export { ForwardRef as ReactComponent };